import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-box',
    templateUrl: './alert-box.component.html',
    styleUrls: ['./alert-box.component.scss'],
    standalone: false
})
export class AlertBoxComponent implements OnInit {

  title: string;
  message: string;
  isPendingNotice: boolean;
  isBulkPendingApproval: boolean;
  isUpdateCoverage: boolean;
  isArchivedStudents: boolean;
  isArchivedStudentsOk: boolean;
  isHeldClaims: boolean;
  constructor(
    private dialogRef: MatDialogRef<AlertBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.message = data.message;
    this.isPendingNotice = data.isPendingNotice;
    this.isBulkPendingApproval = data.isBulkPendingApproval;
    this.isUpdateCoverage = data.isUpdateCoverage;
    this.isArchivedStudents = data.isArchivedStudents;
    this.isArchivedStudentsOk = data.isArchivedStudentsOk;
    this.isHeldClaims = data.isHeldClaims;
  }

  ngOnInit() { }

  ok() {
    this.dialogRef.close(true);
  }
  close(): void {
    this.dialogRef.close(false);
  }
  pendingDataCall(): void {
    this.dialogRef.close("pending");
  }
  BulkPendingCoverage(): void {
    this.dialogRef.close("BulkPendingCoverage");
  }
  UpdateCoverage(): void {
    this.dialogRef.close("UpdateCoverage");
  }
  closePendingPopup(): void {
    this.dialogRef.close("ClosePendingPopup");
  }
  ArchivedStudents(): void {
    this.dialogRef.close("ArchivedStudentsPopup");
  }
  reviewNow(): void {
    this.dialogRef.close({ review: true });
  }
}

